<template>
  <div class="nav-side-bar-500">
    <!-- Toggle Button -->
    <button class="btn btn-primary" @click="toggleSidebar">
      <i class="bi bi-list sidebar500-menu-icon"></i>
    </button>

    <!-- Sidebar -->
    <div class="sidebar" :class="{ 'active': isSidebarOpen }" ref="sidebar">
      <div class="row mx-auto justify-content-center mb-2">
        <div class="col-12 text-center">
          <m-a :href="{ name: 'Home' }">
            <m-img
                :src="findAttributeOnSiteInfo('icon')[0]"
                :alt="findAttributeOnSiteInfo('site_name')[0]"
                class="logo p-3"
            />
          </m-a>
        </div>
        <slot>
          <span class="btn btn-danger mx-2">ثبت نام </span>
          <span class="btn btn-danger">درخواست مشاوره </span>
        </slot>
      </div>

      <!-- Dynamic Menus -->
      <template v-for="menu in storeMenus" :key="menu.id">
        <template v-if="menu.position === menuPosition">
          <div v-for="item in menu.children" :key="item.id" class="color-items">
            <!-- Item with Children -->
            <div class="nav-item" v-if="item.children.length !== 0">
              <div class="text-decoration-none item-name-style" @click="toggleSubmenu(item.id)">
                <span class="nav-link">
                  {{ item.name }}
                  <i class="bi bi-caret-down-fill mx-2 dropdown-icon"></i>
                </span>
              </div>
              <!-- زیرمنو با استایل متفاوت -->
              <transition name="submenu">
                <div v-show="openSubmenus.includes(item.id)" class="nav-item submenu-style">
                  <m-a
                      class="text-decoration-none submenu-link"
                      :href="child.url"
                      v-for="child in item.children"
                      :key="child.id"
                  >
                    <m-menu-icon-manager :item="child"/>
                    <span class="nav-link mr-3">{{ child.name }}</span>
                  </m-a>
                </div>
              </transition>
            </div>
            <!-- Item without Children -->
            <m-base-menu-item
                class="text-dark nav-link"
                v-else
                :item-icon="item.icon_class"
                :item-link="item.url"
                :item-text="item.name"
            />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import mA from "../../Tags/A";
import mImg from "../../Tags/Img.vue";
import mMenuIconManager from "../../Menu/MenuIconManager.vue";
import mMenu3 from "../../Menu/Menu3.vue";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1.vue";
import mSearchInput2 from "../../Search/Input/SearchInput2.vue";
import mBaseMenuItem from "../../Menu/BaseMenuItem";

export default {
  name: "NavSidebar500",
  components: {
    mSearchInput2,
    mShoppingCartCounter1,
    mMenu3,
    mMenuIconManager,
    mA,
    mImg,
    mBaseMenuItem,
  },
  props: {
    menuPosition: {
      default: "blog_nav",
    },
    shoppingCart: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isSidebarOpen: false, // وضعیت باز و بسته بودن سایدبار
      openSubmenus: [], // آرایه‌ای برای مدیریت وضعیت باز بودن زیرمنوها
    };
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
    }),
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    toggleSubmenu(menuId) {
      // اگر منو باز بود، آن را ببندید
      if (this.openSubmenus.includes(menuId)) {
        this.openSubmenus = this.openSubmenus.filter((id) => id !== menuId);
      } else {
        // اگر منو بسته بود، آن را باز کنید
        this.openSubmenus.push(menuId);
      }
    },
    closeSidebarOnClickOutside(event) {
      // اگر کلیک خارج از سایدبار بود، آن را ببند
      const sidebar = this.$refs.sidebar;
      if (sidebar && !sidebar.contains(event.target)) {
        this.isSidebarOpen = false;
      }
    },
  },
  mounted() {
    // افزودن رویداد کلیک به کل سند
    document.addEventListener("mousedown", this.closeSidebarOnClickOutside);
  },
  beforeUnmount() {
    // پاک کردن رویداد کلیک هنگام تخریب کامپوننت
    document.removeEventListener("mousedown", this.closeSidebarOnClickOutside);
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  right: -300px;
  height: 100%;
  width: 300px;
  background: var(--primary);
  color: #fff;
  transition: all 0.3s ease;
  z-index: 1050;
  overflow-y: auto;
}

.sidebar.active {
  right: 0;
}

.sidebar .nav-link {
  color: #fff;
}


.sidebar .nav-link:hover {
  background: var(--secondary);
}

.sidebar500-menu-icon {
  font-size: 15px;
}

.logo {
  height: 5rem;
  object-fit: contain;
  border-radius: 25px;
}

.color-items * {
  color: black !important;
}

.item-name-style {
  cursor: pointer;
}

/* استایل برای زیرمنو */
.submenu-style {
  padding: 5px 5px; /* فاصله داخلی مناسب */
  background-color: var(--primary); /* رنگ پس‌زمینه متفاوت */
  border-left: 2px solid var(--primary); /* نوار تزئینی در کنار زیرمنو */
}

.submenu-style .submenu-link {
  font-size: 0.8rem; /* اندازه فونت کوچکتر */
  color: #555; /* رنگ متن متفاوت */
}

.submenu-style .submenu-link:hover {
  color: var(--primary); /* تغییر رنگ لینک هنگام هاور */
  text-decoration: underline; /* زیرخط هنگام هاور */
}

.dropdown-icon {

  font-size: 10px;

}


/* انیمیشن زیرمنو */
.submenu-enter-active,
.submenu-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.submenu-enter-from,
.submenu-leave-to {
  max-height: 0;
  opacity: 0;
}

.submenu-enter-to,
.submenu-leave-from {
  max-height: 500px; /* مقدار مناسب برای ارتفاع زیرمنو */
  opacity: 1;
}
</style>
